import type { TraceErrorObject } from "owa-analytics-types";
import type { UPSCollaborator } from "places-ups-location-operations";
import { getUpsCollaboratorsFromBuildingId, getUpsCollaboratorsInBuildingError, isUpsOperationForCategoryInProgress, } from "./upsBuildingSelectors";

import type { CollaboratorSource } from "hybridspace-common/lib/serviceTypes";

export function getPeopleInBuildingUpsFromService(category: CollaboratorSource): {
    resultedData: UPSCollaborator[];
    loading: boolean;
    error: TraceErrorObject | undefined;
} {
    // get the UPS data for the users in the Building
    const upsBuildingCollaboratorsDataIsLoading = isUpsOperationForCategoryInProgress(category);
    const upsBuildingCollaboratorsDataError = getUpsCollaboratorsInBuildingError(category);
    const upsBuildingCollaboratorsData = getUpsCollaboratorsFromBuildingId(category);
    
    const error = upsBuildingCollaboratorsDataError;
    
    const resultedData = upsBuildingCollaboratorsData ?? [];
    
    return {
        resultedData,
        loading: upsBuildingCollaboratorsDataIsLoading,
        error,
    };
}
